<template>
  <div class="wrapper" :class="{'is-last': isLast}">
    <div
      :class="level > 0 ? 'child-node-container' : 'node-container'"
      :style="{gridTemplateColumns: titleLength}"
    >
      <div class="horizontal-line"></div>
      <div class="arrow-container">
        <z-icon
          v-if="item.children && item.children.length"
          class="icon-arrow"
          @click="item.open = !item.open"
        >
          {{ item.open ? openedIcon : closedIcon }}
        </z-icon>
        <span
          :class="{
            'body-bold': true,
            'primary-title': level === 0,
            'child-title': level >= 1,
          }"
          >{{ item.title }}</span
        >
      </div>

      <div class="action">
        <!--@slot Slot referente à ação primária do componente 
                  @binding {object} item Objeto do item primário
            -->
        <slot name="action" :level="level" :item="item" :items="items"></slot>
      </div>
    </div>

    <v-expand-transition
      v-if="item.open && item.children && item.children.length"
    >
      <div>
        <div class="child-wrapper">
          <template
            v-for="(child, secondIndex) in item.children.slice(
              0,
              item.children.length - 1
            )"
          >
            <expandable-item
              :key="secondIndex"
              :level="level + 1"
              :item="child"
              :items="item.children.slice(0, item.children.length - 2)"
            >
              <template #action="attrs">
                <slot name="action" v-bind="attrs"></slot>
              </template>
            </expandable-item>
          </template>
        </div>
        <div class="child-wrapper is-last">
          <expandable-item
            is-last
            :level="level + 1"
            :item="item.children[item.children.length - 1]"
            :items="item.children"
          >
            <template #action="attrs">
              <slot name="action" v-bind="attrs"></slot>
            </template>
          </expandable-item>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'ExpandableItem',
  props: {
    items: {
      type: Array,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    openedIcon: {
      type: String,
      default: '$arrow_down',
    },
    closedIcon: {
      type: String,
      default: '$keyboard_arrow_right_rounded',
    },
  },
  computed: {
    titleLength() {
      if (this.items.length === 0) {
        return `min-content ${this.item.title.length + 25}ch 1fr`
      }

      let arr = []
      for (const item of this.items) {
        arr.push(item.title.length)
      }

      let bigger = Math.max(...arr)

      return `min-content ${bigger + 25}ch 1fr`
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;

  .action {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  &.is-last {
    &::before {
      content: none;
    }
  }
  &::before {
    content: '';
    height: calc(100% - 2px);
    position: absolute;
    border-left: dashed 1px #666666;
    left: 0px;
  }

  .node-container {
    display: grid;
    align-items: center;
    margin-top: 8px;
    height: 50px;

    .primary-arrow-container {
      display: flex;
      align-items: center;

      .icon-arrow {
        height: min-content;

        &::after {
          height: unset !important;
        }
      }

      .primary-title {
        margin-left: 5px;
      }
    }

    .primary-horizontal-line {
      width: 20px;
      height: 5px;
      border-bottom: dashed 1px #666666;
    }
  }
}

.horizontal-line {
  width: 26px;
  border-bottom: dashed 1px #666666;
}

.child-wrapper {
  position: relative;
  margin-left: 40px;

  &.is-last {
    &::before {
      height: 32px;
    }
  }

  &::before {
    content: '';
    height: calc(100% - 26px);
    position: absolute;
    border-left: dashed 1px #666666;
    left: 0px;
  }

  .child-node-container {
    display: grid;
    align-items: center;
    height: 50px;

    .child-title {
      margin-left: 5px;
    }
  }
}
</style>
